// extracted by mini-css-extract-plugin
module.exports = {"iconColor":"var(--black)","share":"Share_share__s8_3v","qrCode":"Share_qrCode__mYedY","item":"Share_item__mgXv2"};